module.exports = __webpack_public_path__ + "static/img/sale_error.f858d37.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/sale_error.png
// module id = rgyK
// module chunks = 1